<div class="main-filter-container">
    <div class="filter-container" (click)="isOpen = !isOpen">
        <div class="filter-icon"></div>
        <div class="filter-label" *ngIf="appliedFiltersList.length === 0">{{'GENERAL.FILTER' | translate}}</div>

        <div class="applied-filters-static-bar" *ngIf="appliedFiltersList.length > 0">
            <div *ngFor="let filter of appliedFiltersList" class="applied-filter-static-item">
                <span>{{ currentLang === 'ar' ? filter.labelAr + " " + filter.operator.labelAr : filter.label + " " +
                    filter.operator.label }} {{ filter.valueDes }} |</span>
            </div>
        </div>

        <div class="filter-end">
            <div class="end-icon"></div>
        </div>
    </div>

    <div class="filter-dropdown-container" *ngIf="isOpen">

        <app-select-input-row [bindLabel]="labelKey" bindValue="key"
            [placeholder]="('FILTER.PLACEHOLDER.COLUMN' | translate)" [fetchFn]="getFiltersConfig"
            [fetchSelectedItem]="getFiltersConfig" [errorMessage]="''" (emitSelectOption)="onSelectColumn($event)"
            [control]="getControl('key')"></app-select-input-row>

        <app-select-input-row [bindLabel]="labelKey" bindValue="key"
            [placeholder]="('FILTER.PLACEHOLDER.OPERATOR' | translate)" [fetchFn]="getOperators"
            [fetchSelectedItem]="getOperators" [errorMessage]="''" [control]="getControl('operator')"
            *ngIf="currentOption && formGroup"></app-select-input-row>

        <app-text-input-row [control]="getControl('value')" [errorMessage]="''"
            [placeholder]="('FILTER.PLACEHOLDER.VALUE' | translate)"
            *ngIf="(currentOption?.type === 'text' || currentOption?.type === 'number') && formGroup"
            [type]="currentOption?.type === 'number' ? 'number' : 'text'"></app-text-input-row>

        <app-datepicker1 [control]="getControl('value')" [placeholder]="('FILTER.PLACEHOLDER.VALUE' | translate)"
            class="flex-grow-1 w-100" *ngIf="(currentOption?.type === 'date') && formGroup"></app-datepicker1>
        <div class="my-2" *ngIf="(currentOption?.type === 'date') && formGroup"></div>

        <app-select-input-row [bindLabel]="labelKey" bindValue="key"
            [placeholder]="('FILTER.PLACEHOLDER.OPTION' | translate)" [fetchFn]="getCurrentFilterOptions"
            [fetchSelectedItem]="getCurrentFilterOption" [errorMessage]="''" [control]="getControl('value')"
            *ngIf="currentOption?.type === 'options' && formGroup"
            (emitSelectOption)="currentSelectedOption = $event[labelKey]"></app-select-input-row>

        <app-button [label]="('FILTER.BTN.APPLY' | translate)" btnBgColor="#36A3F7" btnTextColor="#FFFFFF"
            btnHoverBgColor="#36A3F7" btnHoverTextColor="#FFFFFF" style="width: 150px;" (click)="submit()"
            class="w-100 w-md-auto" *ngIf="formGroup?.valid"></app-button>

        <!-- here should show bar with current applied filters :) -->

        <div class="applied-filters-bar d-flex flex-wrap gap-2">
            <div *ngFor="let filter of appliedFiltersList" class="applied-filter-item">
                <span>{{ currentLang === 'ar' ? filter.labelAr + " " + filter.operator.labelAr : filter.label + " " +
                    filter.operator.label }} {{
                    filter.valueDes
                    }}</span>
                <button type="button" class="btn-clear-filter" (click)="removeFilter(filter)">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <app-button
          [label]="('FILTER.BTN.RESET' | translate)"
          [icon]="'assets/media/general/refresh.svg'"
          [btnBgColor]="'#F1416C'"
          [btnHoverBgColor]="'#F1416C'"
          [btnTextColor]="'#FFFFFF'"
          [btnHoverTextColor]="'#FFFFFF'"
          (click)="removeAll()"
        ></app-button>

    </div>
</div>